var nb = {
    ariaLabel: 'Vennligst vent',
};
var nn = {
    ariaLabel: 'Ver vennleg og vent',
};
var en = {
    ariaLabel: 'Please wait',
};
export default { nb: nb, nn: nn, en: en };
